import { saveAffiliatedCompany } from 'commons/service/bank/affiliatedCompany'
import { AffiliatedCompany } from 'commons/types/DTO/bank'
import { WriteHook, useMutationManager } from 'state-manager'

export const useSaveAffiliatedCompany: WriteHook<AffiliatedCompany, AffiliatedCompany> = (opts) =>
  useMutationManager<AffiliatedCompany, AffiliatedCompany>(saveAffiliatedCompany, opts)
